import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const QuotaEndedPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "QuotaEndedPopup" */ './Container'),
  'popup'
);
